import React, { useState, useEffect,useContext } from "react";
import Banner from "../components/Banner";
import StyledSelect from "../components/elements/StyledSelect";
import Header from "../components/Header";
import PrimeLayout from "../components/PrimeLayout";
import { Grid } from "@mui/material";
import StyledButton from "../components/elements/StyledButton";
import {
  adminProcessedFilesHeadCells,
  userProcessedFilesHeadCells,
} from "../constants/Data";
import DatePicker from "../components/elements/DatePicker";
import StyledTable from "../components/StyledTable";
import Pagination from "../components/elements/Pagination";
import { saveAs } from "file-saver";
import { getAllFiles } from "../services/api/processedFiles.api";
import {getAllCountries} from "../services/api/country.api";
import { getCurrentUserDetails } from "../services/api/users.api";
import { toast } from "react-toastify";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { BiSearchAlt } from "react-icons/bi";
import { downloadFile } from "../services/api/fileUpload";
import Footer from "../components/Footer";

import {AppContext} from "../context/Context";

function ProcessedFiles() {
  const [statusOptions] = useState(["processing", "success", "error"]);
  const [modelOptions, setModelOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [fileRowData, setFileRowData] = useState([]);
  const [paginatedData, setPaginatedData] = useState();
  const [order, setOrder] = useState({ id: "updated_date", sort: "asc" });
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState("init");
  const [country, setCountry] = useState("init");
  const [model, setModel] = useState("init");
  const [user, setUser] = useState("init");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [dateRange, setDateRange] = useState([null, null]);
  const [userDetails, setUserDetails] = useState(null);
  const [countries,setCountries] = useState([])

  useEffect(()=>{
    const getCountries = async()=>{
      try{
        let response = await getAllCountries();
        setCountries(response);
      }catch(err){
        console.log(err);
        toast.error(err.message, { theme: "colored" });
      }
    }
    getCountries();
    // eslint-disable-next-line
  },[]);

  useEffect(() => {
    const populateProcessedFileDetails = async () => {
      try {
        setLoading(true);
        const currentUser = await getCurrentUserDetails();
        setUserDetails(currentUser);
        // obtain local UTC offset and convert to msec to T00:00:00.000Z --> dateRange[0].getTimezoneOffset() * 60000
        const dateFrom = dateRange[0]
          ? new Date(
              dateRange[0] - dateRange[0].getTimezoneOffset() * 60000
            ).toISOString()
          : null;
        // obtain local UTC offset and convert to msec to 23:59:00.000Z --> dateRange[1].getTimezoneOffset() * ((23 + ( 59/ 60 ) + 5.5 ) / 5.5) * 60000
        const dateTo = dateRange[1]
          ? new Date(
              dateRange[1] -
                dateRange[1].getTimezoneOffset() *
                  ((23 + 59 / 60 + 5.5) / 5.5) *
                  60000
            ).toISOString()
          : null;
        let filterRole = null;
        if (user !== "init") {
          filterRole = user;
        }

        try {
          const params = {
            limit: 10,
            offset: page,
            order: order.sort,
            key: order.id,
            user:
              currentUser.user_role === "user" ? currentUser.name : filterRole,
            model: model === "init" ? null : model,
            country: country === "init" ? null : country,
            dateFrom: dateFrom,
            dateTo: dateTo,
            status: status === "init" ? null : status,
          };
          try {
            const fileData = await getAllFiles(params);
            setPaginatedData(fileData);
            const rowFiles = fileData.docs.map((d) => {
              if (currentUser.user_role === "user") {
                return {
                  id: d._id,
                  uploaded_file: d.uploaded_file.name + ".xlsx",
                  model: d.template.name,
                  model_version: d.version,
                  country: d.country,
                  date_time: moment(d.updated_date).format("DD/MM/YYYY, HH:mm"),
                  status: d.status,
                  output: d.output_url ? d.output_url : null,
                  remark: d.remark,
                };
              } else {
                return {
                  id: d._id,
                  name: d.user.name,
                  uploaded_file: d.uploaded_file.name + ".xlsx",
                  model: d.template.name,
                  model_version: d.version,
                  country: d.country,
                  date_time: moment(d.updated_date).format("DD/MM/YYYY, HH:mm"),
                  status: d.status,
                  output: d.output_url ? d.output_url : null,
                  remark: d.remark,
                };
              }
            });
            setFileRowData([...rowFiles]);
            setUserOptions(fileData.users);
            setModelOptions(fileData.models);
            setLoading(false);
          } catch (err) {
            if (err.message === "No active account") {
              toast.error("Session Expired, Please Log back", {
                theme: "colored",
              });
              return navigate("/");
            }
            toast.error(err.message, { theme: "colored" });
            setLoading(false);
          }
        } catch (err) {
          if (err.message === "No active account") {
            toast.error("Session Expired, Please Log back", {
              theme: "colored",
            });
            return navigate("/");
          }
          toast.error(err.message, { theme: "colored" });
          setLoading(false);
        }
      } catch (err) {
        if (err.message === "No active account") {
          toast.error("Session Expired, Please Log back", {
            theme: "colored",
          });
          return navigate("/");
        }
        toast.error(err.message, { theme: "colored" });
        setLoading(false);
      }
    };
    populateProcessedFileDetails();
    // eslint-disable-next-line
  }, [page, order]);

  const getPage = (p) => {
    setPage(p);
  };

  const downloadOutputFile = async (e) => {
    try {
      const downloadURL = await downloadFile({
        name: encodeURI(`${e.id}/${e.id}.zip`),
        bucket: "output",
      });
      saveAs(downloadURL, `${e.id}.zip`);
    } catch (err) {
      toast.error("Failed to download template", { theme: "colored" });
    }
  };

  const downloadUploadFile = async (e) => {
    try {
      const downloadURL = await downloadFile({
        name: encodeURI(`${e.id}/${e.id}.xlsx`),
      });
      saveAs(downloadURL, `${e.id}.xlsx`);
    } catch (err) {
      toast.error("Failed to download template", { theme: "colored" });
    }
  };

  const searchArray = async () => {
    try {
      // obtain local UTC offset and convert to msec to T00:00:00.000Z --> dateRange[0].getTimezoneOffset() * 60000
      const dateFrom = dateRange[0]
        ? new Date(
            dateRange[0] - dateRange[0].getTimezoneOffset() * 60000
          ).toISOString()
        : null;
      // obtain local UTC offset and convert to msec to 23:59:00.000Z --> dateRange[1].getTimezoneOffset() * ((23 + ( 59/ 60 ) + 5.5 ) / 5.5) * 60000
      const dateTo = dateRange[1]
        ? new Date(
            dateRange[1] -
              dateRange[1].getTimezoneOffset() *
                ((23 + 59 / 60 + 5.5) / 5.5) *
                60000
          ).toISOString()
        : null;
      setPage(1);
      setLoading(true);
      const params = {
        limit: 10,
        offset: page,
        order: order.sort,
        key: order.id,
        status: status === "init" ? null : status,
        model: model === "init" ? null : model,
        user:
          user === "init" && userDetails.user_role !== "user"
            ? null
            : userDetails.user_role === "user"
            ? userDetails.name
            : user,
        country: country === "init" ? null : country,
        dateFrom: dateFrom,
        dateTo: dateTo,
      };
      const fileData = await getAllFiles(params);
      setPaginatedData(fileData);
      const rowFiles = fileData.docs.map((d) => {
        if (userDetails.user_role === "user") {
          return {
            id: d._id,
            uploaded_file: d.uploaded_file.name + ".xlsx",
            model: d.template.name,
            model_version: d.version,
            country: d.country,
            date_time: moment(d.updated_date).format("DD/MM/YYYY, HH:mm"),
            status: d.status,
            output: d.output_url ? d.output_url : null,
            remark: d.remark,
          };
        } else {
          return {
            id: d._id,
            name: d.user.name,
            uploaded_file: d.uploaded_file.name + ".xlsx",
            model: d.template.name,
            model_version: d.version,
            country: d.country,
            date_time: moment(d.updated_date).format("DD/MM/YYYY, HH:mm"),
            status: d.status,
            output: d.output_url ? d.output_url : null,
            remark: d.remark,
          };
        }
      });
      setFileRowData([...rowFiles]);
      setUserOptions(fileData.users);
      setModelOptions(fileData.models);
      setLoading(false);
    } catch (err) {
      if (err.message === "No active account") {
        toast.error("Session Expired, Please Log back", {
          theme: "colored",
        });
        return navigate("/");
      }
      toast.error(err.message, { theme: "colored" });
      setLoading(false);
    }
  };

  return (
    <div>
      <Header />
      <Banner small />
      <PrimeLayout title="Processed Files">
        <Grid
          container
          spacing={2}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Grid item xs={12} md={3} lg={2}>
            <StyledSelect
              label={"Status"}
              defaultVal={"Select the Status"}
              options={statusOptions}
              control={status}
              setControl={setStatus}
            />
          </Grid>
          <Grid item xs={12} md={3} lg={2}>
            <StyledSelect
              label={"Module"}
              defaultVal={"Select the Module"}
              options={modelOptions}
              control={model}
              setControl={setModel}
            />
          </Grid>
          <Grid item xs={12} md={3} lg={2}>
            <StyledSelect
              label={"Country"}
              defaultVal={"Select the Country"}
              options={countries}
              control={country}
              setControl={setCountry}
            />
          </Grid>
          {userDetails && userDetails.user_role !== "user" && (
            <Grid item xs={12} md={3} lg={2}>
              <StyledSelect
                label={"User"}
                defaultVal={"Select User"}
                options={userOptions}
                control={user}
                setControl={setUser}
              />
            </Grid>
          )}
          <Grid item xs={12} md={4} lg={3}>
            <DatePicker dateRange={dateRange} setDateRange={setDateRange} />
          </Grid>
          <Grid item xs={12} md={3} lg={2}>
            <div style={{ margin: "auto", width: "fit-content" }}>
              <StyledButton
                iconLeft={<BiSearchAlt size={25} />}
                variant={"outlined"}
                style={{ marginTop: "25px" }}
                onClick={() => {
                  searchArray();
                }}
              >
                Search
              </StyledButton>
            </div>
          </Grid>
          <Grid xs={12} md={12}>
            <StyledTable
              headCells={
                userDetails && userDetails.user_role === "user"
                  ? userProcessedFilesHeadCells
                  : adminProcessedFilesHeadCells
              }
              rows={fileRowData}
              chips={"status"}
              files={"uploaded_file"}
              output={"output"}
              order={order}
              loading={loading}
              setOrder={setOrder}
              onOutputFileClick={downloadOutputFile}
              onFileClick={downloadUploadFile}
            />
            {paginatedData?.totalPages > 1 && !loading && (
              <Pagination
                count={paginatedData?.totalPages}
                getPage={getPage}
                page={page}
              />
            )}
          </Grid>
        </Grid>
      </PrimeLayout>
      <Footer/>
    </div>
  );
}

export default ProcessedFiles;
